import { AppProps } from 'next/app'
import Head from 'next/head'
import * as Sentry from '@sentry/nextjs'
import { StyleSheetManager } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'

import '../styles/global.scss'
import CookieHubLoader from '../container/cookie-consent/CookieHubLoader'
import Page from '../components/page/Page'
import ErrorBoundaryFallback from '../components/error-boundary-fallback/ErrorBoundaryFallback'

interface AppErrorProps {
	err: any
}

const App = ({ Component, pageProps, err }: AppProps & AppErrorProps) => {
	return (
		// styled-components v6 no longer filters unknown props off DOM nodes automatically.
		// Restore the v5 behavior globally: forward a prop only if it's a valid HTML/SVG
		// attribute when the target is a DOM element; always forward to custom components.
		<StyleSheetManager shouldForwardProp={(prop, target) => (typeof target === 'string' ? isPropValid(prop) : true)}>
			<Page>
				<Head>
					<link rel='preload' href='/fonts/CircularXXWeb-Regular.woff' as='font' type='font/woff' />
					<link rel='preload' href='/fonts/CircularXXWeb-Bold.woff' as='font' type='font/woff' />
					<link rel='preload' href='/fonts/CircularXXWeb-Light.woff' as='font' type='font/woff' />
					<link rel='preload' href='/fonts/CircularXXWeb-Book.woff' as='font' type='font/woff' />
					<meta name='facebook-domain-verification' content='h82aa7hydbn88nwlii4zheuah9nnas' />
				</Head>
				<Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
					<Component {...pageProps} err={err} />
					<CookieHubLoader />
				</Sentry.ErrorBoundary>
			</Page>
		</StyleSheetManager>
	)
}

export default App
